export default __webpack_public_path__ + "static/media/hotel-1.1dd24be6.jpg";